import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as PR from "../../../prime-react/index";
import Layout from "../../../layouts/Layout";
import "./UserManagement.scss";
import {
    getuserManagementGroupsnewAPI,
    getSportsnewAPI,
    getLocationsnewAPI,
    getGroupsnewAPI,
    getTournamentLevelsnewAPI,
} from "../../../services/api";
import { useSelector } from "react-redux";
import { pagecount } from "../../../utils/reuse";
import { action, groupName, Header, PaginationTemplate, status, userCount, userDescription } from "./helper";
import { FormPopUp, userMformError } from "./FormPopUp/FormPopUp";
import { useToast } from "../../../context/ToastContext";

const UserManagement = () => {
    const { showToast, clearError } = useToast();
    const [userData, setUserData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [sortOrder, setSortOrder] = useState(1);
    const [optionLoading, setOptionLoading] = useState(false);
    const userFilterState = useSelector(state => state.userFilter);
    const query = useRef({
        limit: pagecount + 1,
        offset: 0,
        search: userFilterState?.search ?? '',
        role: userFilterState?.role?.length ?  userFilterState?.role.map(r => r.id).toString() : '',
        sort_by: 'status',
        sort_order: sortOrder === 1 ? 'asc' : 'desc',
    });
    const sessionData = useSelector((state) => state.auth.sessionData);
    const headers = useMemo(() => ({ sessionid: sessionData.sessionId }), [sessionData.sessionId]);
    const [formPopUp, setFormPopUp] = useState({ visible: false, id: '', userId:'', role:'' });
    const formOptions = useRef(null)
    const navigate = useNavigate();

    const fetchData = useCallback(async () => {
        setLoading(true);
        const { result, data, error } = await getuserManagementGroupsnewAPI(new URLSearchParams(query.current).toString(), headers);
        if (result === 'SUCCESS') setUserData(data);
        else {
            setUserData([]);
            showToast(error.severity, error.errorMsg || error.summary);
        };
        setLoading(false);
        return result === 'SUCCESS';
    }, [headers, showToast]);

    useEffect(() => {
        (async()=>{
            setOptionLoading(true)
            const { data: unsortedSports } = await getSportsnewAPI(headers);
            const { data: unsortedLocations } = await getLocationsnewAPI(headers);
            const { data: unsortedMemberIds } = await getGroupsnewAPI(2, headers);
            const { data: unsortedTournamentLevels } = await getTournamentLevelsnewAPI(headers);
            setOptionLoading(false)

            //
            const sports = unsortedSports?.sort((a, b) => a.name.localeCompare(b.name))
            const locations = unsortedLocations?.sort((a, b) => a.name.localeCompare(b.name))
            const memberIds = unsortedMemberIds?.sort((a, b) => a.name.localeCompare(b.name))
            const tournamentLevels = unsortedTournamentLevels?.sort((a, b) => a.name.localeCompare(b.name))

            formOptions.current = {
                sports,
                locations,memberIds,tournamentLevels}; 
        })();
    }, [headers])

    useEffect(() => {
        query.current.sort_by = 'status';
        query.current.sort_order = sortOrder === 1 ? 'asc' : 'desc';
        query.current.limit = pagecount + 1;
        query.current.offset = 0;
        fetchData();
    }, [fetchData, sortOrder]);

    const closeFormPopUp = () => { clearError(userMformError);  document.body.classList.remove('p-overflow-hidden'); setFormPopUp({ visible: false, id: '', userId:'', role:'' }) }

    const onSubmitted = response =>{closeFormPopUp(); showToast(response.severity, response.detail);} 

    const viewDetailsHandler = ({ id, name, status, role }) => navigate(`/all-users?${new URLSearchParams({ id}).toString()}`);

    const editHandler = v =>  {setFormPopUp({ visible: true,...v,  userId:v.id, id: 'edit' });}
 
    return <Layout backBtn={"home"} backBtnLabel="Home">
        <section className="usermanagement-section all-alerts-section all-tags-section mt-1">
            <div className="m-0">
                <h1>User Management</h1>
            </div>
            <div className="alerts-tab mt-2">
                <div className="grid grid-nogutter">
                    <div className="card col-12 relative">
                        <PR.DataTable
                            value={userData?.slice(0, pagecount)}
                            stripedRows className="data-table"
                            footer={<PaginationTemplate query={query.current} data={userData} refetch={fetchData} />}
                            header={<Header query={query.current} setFormPopUp={() => { setFormPopUp({ visible: true, id: 'new', userId:'', role:'' }) }} refetch={fetchData} headers={headers}/>}
                            loading={loading}
                            sortField={'status'}
                            sortOrder={sortOrder}
                            onSort={({ sortOrder: v }) => { setSortOrder(v); }}
                        >
                            <PR.Column field="name" header="User Groups" body={groupName}  />
                            <PR.Column body={userDescription} header="Description"  />
                            <PR.Column body={userCount} header="No.of Profiles" />
                            <PR.Column body={status} header="Status" field="status" sortable sortField="status"/>
                            <PR.Column body={action.bind(null, viewDetailsHandler, editHandler)} header="Action" className="last-column" />
                        </PR.DataTable>
                    </div>
                </div>
            </div>
        </section>
        {!!formPopUp.visible && <FormPopUp options={formOptions.current} refetch={fetchData} optionLoading={optionLoading} data={formPopUp} headers={headers} onSubmitted={onSubmitted} onClose={closeFormPopUp} />}
    </Layout>
}

export default UserManagement;
